(function () {
  'use strict';

  angular
    .module('factories.mobileHelper', ['factories.nativeBridge'])
    .factory('MobileHelper', MobileHelper);

  MobileHelper.$inject = ['NativeBridge', '$window', '$timeout', '$rootScope'];

  function MobileHelper(NativeBridge, $window, $timeout, $rootScope) {
    var ipadVersion = null;
    var ipadVersionCalledBack = null;

    var nativeAppVersion = null;
    var nativeAppVersionCalledBack = null;

    function isTouch() {
      if ($window.Modernizr)
        return $window.Modernizr.touch;

      try {
        return ('ontouchstart' in $window.document.documentElement);
      } catch (e) {
        return false;
      }
    }

    function isMobileHeight() {
      return $window.innerHeight <= 670;
    }

    function isIpad() {
      return $window.navigator.userAgent.match(/iPad/i) != null;
    }

    function isMobileDevice() {
      return isIOS() || isAndroid() || isBlackBerry() || isIEMobile();
    }

    function isIOS() {
      return $window.navigator.userAgent.match(/iPhone|iPad|iPod/i) != null;
    }

    function isAndroid() {
      // Need to check Silk as well because if Kindle Fire serve your page in desktop mode automatically it won't
      // have Android in the user agent string.
      return $window.navigator.userAgent.match(/Android/i) != null ||
        $window.navigator.userAgent.match(/Silk/i) != null;
    }

    function isAndroidDefaultBrowser() {
      return $window.navigator.userAgent.indexOf('Mozilla/5.0') > -1 &&
        $window.navigator.userAgent.indexOf('Android ') > -1 &&
        $window.navigator.userAgent.indexOf('AppleWebKit') > -1 &&
        $window.navigator.userAgent.indexOf('Chrome') == -1;
    }

    function isBlackBerry() {
      return $window.navigator.userAgent.match(/BlackBerry/i) != null;
    }

    function isIEMobile() {
      return $window.navigator.userAgent.match(/IEMobile/i) != null;
    }

    function supportsHLS() {
      var isSafari6OrGreater = $window.BrowserDetect && $window.BrowserDetect.browser == 'Safari' &&
        $window.BrowserDetect.version >= 6;
      return isIOS() || isSafari6OrGreater;
    }

    function willGoNativeFullScreen() {
      return $window.navigator.userAgent.match(/iPhone|iPod/i) != null;
    }

    function getIpadVersion(cb) {
      if (!ipadVersion) {
        if ($window.isNativeIpadApp) {
          ipadVersionCalledBack = false;
          $timeout(function () {
            if (!ipadVersionCalledBack) {
              ipadVersionCalledBack = true;
              cb(ipadVersion || '');
            }
          }, 2000);
          NativeBridge.fireHandler('ipadVersion', null, function (val) {
            if (ipadVersionCalledBack) return;
            ipadVersionCalledBack = true;
            ipadVersion = val;
            $rootScope.$apply(function () {
              cb(ipadVersion || '');
            });
            return;
          });
        } else {
          cb('');
        }
      } else {
        cb(ipadVersion || '');
      }
    }

    function getNativeAppVersion(cb) {
      if (!nativeAppVersion) {
        if ($window.isNativeIpadApp) {
          var nativeAppVersionString = $window.navigator.userAgent.match(/Mindflash iOS App v.*/i);
          if (nativeAppVersionString) {
            nativeAppVersion = nativeAppVersionString[0].replace('Mindflash iOS App v.', '');
            nativeAppVersion = getMajorVersionNumber(nativeAppVersion);
            return cb(nativeAppVersion);
          } else {
            nativeAppVersionCalledBack = false;
            // We can eventually delete this else block once we cut off Native version < 1.6.
            $timeout(function () {
              if (!nativeAppVersion) {
                nativeAppVersionCalledBack = true;
                cb(nativeAppVersion || 0);
              }
            }, 2000);
            NativeBridge.fireHandler('nativeAppVersion', null, function (val) {
              if (nativeAppVersionCalledBack) return;
              nativeAppVersionCalledBack = true;
              nativeAppVersion = getMajorVersionNumber(val);

              $rootScope.$apply(function () {
                cb(nativeAppVersion || 0);
              });
              return;
            });
          }
        } else {
          cb(0);
        }
      } else {
        cb(nativeAppVersion || 0);
      }
    }

    function getMajorVersionNumber(versionNumberString) {
      var versionNumber = versionNumberString;
      // Only use major and minor version numbers. Build number ignored for point of feature comparison at the moment.
      var secondPeriodIndex = versionNumberString.indexOf('.', 2);
      if (secondPeriodIndex >= 0)
        versionNumber = versionNumberString.substr(0, secondPeriodIndex);
      return versionNumber;
    }

    function getNativeInfo(cb) {
      var data = {};
      var hasReturnedIpadVersion = null;
      var hasReturnedNativeVersion = null;

      getIpadVersion(function (value) {
        data.ipadVersion = value;
        hasReturnedIpadVersion = true;
        if (hasReturnedNativeVersion) cb(data);
      });

      getNativeAppVersion(function (value) {
        data.nativeAppVersion = value;
        hasReturnedNativeVersion = true;
        if (hasReturnedIpadVersion) cb(data);
      });
    }

    function useIpadRoutes() {
      return $window.isNativeIpadApp || $window.useIpadRoutes;
    }

    return {
      isAndroid: isAndroid,
      isAndroidDefaultBrowser: isAndroidDefaultBrowser,
      isBlackBerry: isBlackBerry,
      isIEMobile: isIEMobile,
      isTouch: isTouch,
      isIOS: isIOS,
      isIpad: isIpad,
      isMobileHeight: isMobileHeight,
      isMobileDevice: isMobileDevice,
      isNativeIpadApp: $window.isNativeIpadApp,
      useIpadRoutes: useIpadRoutes,
      supportsHLS: supportsHLS,
      getIpadVersion: getIpadVersion,
      getNativeAppVersion: getNativeAppVersion,
      getNativeInfo: getNativeInfo,
      willGoNativeFullScreen: willGoNativeFullScreen
    };
  }

})();
